import React from 'react';
import { NavLink } from 'react-router-dom';

class Footer extends React.Component {
    render() {
        return (
            <footer>
                <div className="container">
                    <div>
                        <h3>Sitemap</h3>
                        <div className="horizontal">
                            <div>
                                <NavLink to="/">Home</NavLink>
                                <NavLink to="/buy">Buy</NavLink>
                                <NavLink to="/let">Let</NavLink>
                                <NavLink to="/commercial">Commercial</NavLink>
                                <a href="/privacy-policy.pdf" target={"_blank"}>Privacy Policy</a>
                                <a href="/cookie-policy.pdf" target={"_blank"}>Cookies Policy</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3>Social Media</h3>
                        <div>
                            <div className={"social"}>
                                <a href={"https://www.facebook.com/PartnersRealEstateIOM"} target={"_blank"}>
                                    <img src={require("../../images/social/facebook.svg")} alt={"Facebook"} />
                                </a>
                                <a href={"https://www.instagram.com/partnersrealestateiom/"} target={"_blank"}>
                                    <img src={require("../../images/social/instagram.svg")} alt={"Facebook"} />
                                </a>
                                <a href={"https://www.linkedin.com/company/partners-real-estate-isle-of-man"} target={"_blank"}>
                                    <img src={require("../../images/social/linkedin.svg")} alt={"Facebook"} />
                                </a>
                                <a href={"https://www.youtube.com/@PartnersRealEstateGlobal"} target={"_blank"}>
                                    <img src={require("../../images/social/youtube.svg")} alt={"Facebook"} />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3>Contact</h3>
                        <div>
                            <a href="tel:01624 777 044">01624 777 044</a>
                            <a href="mailto:hello@partners.co.im">hello@partners.co.im</a>
                            <p>64 Duke Street, Douglas, Isle of Man, IM1 2AR</p>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="container">
                    <p>&copy; Partners Real Estate 2025</p>
                </div>
            </footer>
        );
    }
}

export default Footer;
